module.exports = __webpack_public_path__ + "static/media/adhesivo_zocalos.3b68902b.jpg";